import React, { useEffect, useState } from 'react';

/**
 * Order Confirmation Modal
 * Shows 4-digit code after successful order creation
 * Auto-resets in kiosk mode
 */
export default function OrderConfirmationModal({ code, onDone }) {
  const [countdown, setCountdown] = useState(15);
  const isKiosk = document.body.classList.contains('kiosk-mode');

  useEffect(() => {
    if (isKiosk) {
      const timer = setInterval(() => {
        setCountdown(prev => {
          if (prev <= 1) {
            clearInterval(timer);
            onDone();
            return 0;
          }
          return prev - 1;
        });
      }, 1000);

      return () => clearInterval(timer);
    }
  }, [isKiosk, onDone]);

  return (
    <div className="order-confirmation-modal">
      <div className="order-modal-overlay" />
      <div className="order-modal-content">
        <div className="order-success-icon">✓</div>
        
        <h1 className="order-modal-title">Order Sent!</h1>
        
        <p className="order-modal-subtitle">
          Show this code at the till:
        </p>

        <div className="order-code">
          {code}
        </div>

        <div className="order-modal-instructions">
          <p>✓ Your order has been sent to the till</p>
          <p>✓ Tell staff your code to complete payment</p>
          <p>✓ Keep this screen until your order is processed</p>
        </div>

        <button
          className="order-done-btn"
          onClick={onDone}
        >
          {isKiosk && countdown > 0 
            ? `Done (auto-close in ${countdown}s)` 
            : 'Start New Order'
          }
        </button>
      </div>
    </div>
  );
}
